import Help from '@vegascom/minerva-ui';
import React, { useContext } from 'react';
import useDocumentationService from './useDocumentationService';
import { AppBar, Grid, Typography } from '@material-ui/core';
import Toolbar from '@material-ui/core/Toolbar';
import { TokenContext } from './TokenProvider';
const logo = require('./logo.svg').default;

export const HelpDev = () => {
  const params = new URLSearchParams(window.location.search);
  const token = useContext(TokenContext);
  const service = useDocumentationService(
    token,
    params.get('app') || '',
  );

  return token ? (
    <>
      <AppBar position="fixed" color="primary" style={{ backgroundColor: '#516FA3' }}>
        <Toolbar>
          <Grid container alignItems="center" spacing={1}>
            <Grid item>
              <img src={logo} alt="Vegas.com logo" />
            </Grid>
            <Grid item>
              <Typography variant="h6">Help Search</Typography>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <div style={{ marginTop: '6em' }}>
        <Help {...service} />
      </div>
    </>
  ) : (
    <>Unauthorized</>
  );
};
